import React from 'react'
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import "./Footer.scss";
import footerPhoto from "../../images/Logotipo-20250223T170103Z-001/Logotipo/logo_macarenapereira_abogada_verde.jpg"
const Footer = () => {

    const handleInstagram = () => {
        console.log("a")
        const url = "https://www.instagram.com"
        window.open(url, '_blank')
    };

  return (
    <div>
        <div className='footer-box d-flex justify-content-center p-4 text-center'>
            <Container>
                <Row xs={1} sm={1} md={1}>
                    <Col >
                            <Button
                                    href="mailto:macarenapereiraabogada@gmail.com"
                                    variant='link'
                                    style={{ textDecoration: 'none', color: 'white' }}    
                                    ><img className="footer-img" src={footerPhoto}/>
                            </Button>
                    </Col>
                </Row>
            </Container>
        </div>
    </div>
  )
}

export default Footer